<script>
import TypeaheadComponent from '@/components/Typeahead.vue'
import vmware_requestService from '@/api-services/vmware_request.service'
import RuleFormGroup from '@/components/requests/vmware/RuleFormGroup.vue'

export default {
  name: 'OuInput',
  components: { RuleFormGroup, TypeaheadComponent },
  data() {
    return {
      organizational_units: [],
      loading: false,
      query: '',
    }
  },
  props: {
    value: { default: null },
    label: { type: String, required: true },
  },
  methods: {
    textOf(ou) {
      return ou && ou.fq_name != null ? String(ou.fq_name) : ''
    },
    onInput(text) {
      this.query = text
      if (this.value !== null && this.value !== undefined && text !== this.textOf(this.value)) {
        this.$emit('input', null)
      }
    },
    onSelect(item) {
      this.$emit('input', item)
    },
    async fetchOrganizationalUnits() {
      this.loading = true
      try {
        const resp = await vmware_requestService.list_idm_synced_ous(this.$store.state)
        this.organizational_units = resp.data.ou_list
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.fetchOrganizationalUnits()
  },
  computed: {
    rules() {
      return [
        {
          satisfied: this.value !== null && this.value !== undefined,
          message: () => 'Bitte einen Eintrag aus der Liste auswählen',
        },
      ]
    }
  },
  watch: {
    // Wert von außen gesetzt (z. B. Formular vorbelegt) -> Text anpassen
    value: {
      immediate: true,
      handler(v) {
        if (v !== null && v !== undefined && this.textOf(v) !== this.query) {
          this.query = this.textOf(v)
        }
      },
    },
  },
}
</script>

<template>
  <rule-form-group
    :label="label"
    :value="query"
    :rules="rules"
    :optional="true"
    @validity-change="$emit('validity-change', $event)"
  >
    <template #default>
      <typeahead-component
        :value="query"
        :data="organizational_units"
        :serializer="(ou => ou ? ou.fq_name : '')"
        :loading="loading"
        @input="onInput"
        @select="onSelect"
      />
    </template>
  </rule-form-group>
</template>

<style scoped>

</style>
